import type { TooltipDesignTokens, TooltipTokenSections } from '@openng/optimus-ui-themes/types/tooltip';

export const root: TooltipTokenSections.Root = {
    maxWidth: '12.5rem',
    gutter: '0.25rem',
    shadow: '{overlay.popover.shadow}',
    padding: '0.5rem 0.75rem',
    borderRadius: '{overlay.popover.border.radius}'
};

export const colorScheme: TooltipTokenSections.ColorScheme = {
    light: {
        root: {
            background: '{surface.800}',
            color: 'var(--color-text-common-inverse-contrast)'
        }
    },
    dark: {
        root: {
            background: '{surface.800}',
            color: 'var(--color-text-common-inverse-contrast)'
        }
    }
};

export default {
    root,
    colorScheme
} satisfies TooltipDesignTokens;
